import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { ArrowRightIcon, ExternalLinkIcon } from "@gemini/icons";
export const ProviderLink = ({ onClick, label, testId, toExternalSource = false, }) => {
    return (_jsxs(Box, { as: "a", testId: testId, cursor: "pointer", display: "flex", alignItems: "end", gap: "spacing.4", onClick: onClick, children: [_jsx(Box, { as: "span", marginTop: "spacing.8", typography: "typography.body.16.regularUnderlined", children: label }), toExternalSource ? _jsx(ExternalLinkIcon, {}) : _jsx(ArrowRightIcon, {})] }));
};
